import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Login } from './Login';
import { RegistrationSuccessful } from './RegistrationSuccessful';
import { Register } from './Register';
import { NotFound } from './NotFound';
import { Main } from './Main';
import { Reserve } from './Reserve';
import { Rent } from './Rent';
import { RentExit } from './RentExit';
import { Client } from './Client';
import { CheckoutRent } from './CheckoutRent';
import { PasswordReset } from './PasswordReset';
import { PasswordResetConfirm } from './PasswordResetConfirm';
import { CheckEmailReset } from './CheckEmailReset';
import { CheckEmailRegistration } from './CheckEmailRegistration';
import { CheckoutRentExit } from './CheckoutRentExit';
import { CheckoutRentContinue } from './CheckoutRentContinue';
import { RentContinue } from './RentContinue';

// eslint-disable-next-line react/prop-types
function PrivateRoute({ children, ...rest }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (isAuthenticated) return children;
        else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          );
        }
      }}
    />
  );
}

const RouteProvider = () => {
  return (
    <Switch>
      {/* Private routes */}
      <PrivateRoute exact path="/client/:clientId">
        <Client />
      </PrivateRoute>

      <PrivateRoute exact path="/rent/:rentId/checkout">
        <CheckoutRent />
      </PrivateRoute>
      <PrivateRoute exact path="/rent/:rentId/checkout/exit">
        <CheckoutRentExit />
      </PrivateRoute>
      <PrivateRoute exact path="/rent/:rentId/checkout/continue">
        <CheckoutRentContinue />
      </PrivateRoute>

      <PrivateRoute exact path="/rent/checkout">
        <CheckoutRent />
      </PrivateRoute>

      <PrivateRoute exact path="/rent/:rentId/edit">
        <Rent isEdit={true} />
      </PrivateRoute>

      <PrivateRoute exact path="/rent/:rentId/exit">
        <RentExit />
      </PrivateRoute>

      <PrivateRoute exact path="/rent/:rentId/continue">
        <RentContinue />
      </PrivateRoute>

      <PrivateRoute exact path="/rent/:rentId">
        <Rent />
      </PrivateRoute>

      <PrivateRoute exact path="/rent">
        <Rent />
      </PrivateRoute>

      <PrivateRoute exact path="/reservation/:reserveId/edit">
        <Reserve isEdit={true} />
      </PrivateRoute>

      <PrivateRoute exact path="/reservation/:reserveId">
        <Reserve />
      </PrivateRoute>

      <PrivateRoute exact path="/reservation">
        <Reserve />
      </PrivateRoute>

      <PrivateRoute exact path="/">
        <Main />
      </PrivateRoute>

      {/* Public routes */}
      <Route exact path="/check-email-registration" component={CheckEmailRegistration} />
      <Route exact path="/check-email-reset" component={CheckEmailReset} />
      <Route exact path="/recovery-input" component={PasswordResetConfirm} />
      <Route exact path="/registration-successful" component={RegistrationSuccessful} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/reset" component={PasswordReset} />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export { RouteProvider };
